import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { RequireAuth } from './auth/RequireAuth';
import { Home } from './pages/Home';
import { SignIn } from './pages/SignIn';
import { SignUp } from './pages/SignUp';
import { EventsList } from './pages/EventsList';
import { EventCreate } from './pages/EventCreate';
import { EventJoin } from './pages/EventJoin';
import { EventLobby } from './pages/EventLobby';
import { EventScoreEntry } from './pages/EventScoreEntry';
import { EventLeaderboard } from './pages/EventLeaderboard';
import { Scorecard } from './pages/Scorecard';
import { NotFound } from './pages/NotFound';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 5_000 },
  },
});

function Header() {
  const { actor, signOut } = useAuth();
  return (
    <header className="app-header">
      <Link to="/" className="brand">MY GOLF EVENT</Link>
      <nav className="row" style={{ gap: 12 }}>
        {actor?.kind === 'user' ? (
          <>
            <Link to="/events">Events</Link>
            <button
              type="button"
              onClick={() => signOut()}
              style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', fontWeight: 600 }}
            >
              Sign out
            </button>
          </>
        ) : actor?.kind === 'guest' ? (
          <>
            <span style={{ fontSize: 13, opacity: 0.85 }}>Guest: {actor.guest.displayName}</span>
            <Link to="/signup">Sign up</Link>
          </>
        ) : (
          <>
            <Link to="/signin">Sign in</Link>
            <Link to="/signup">Sign up</Link>
          </>
        )}
      </nav>
    </header>
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/events" element={<RequireAuth><EventsList /></RequireAuth>} />
            <Route path="/events/new" element={<RequireAuth><EventCreate /></RequireAuth>} />
            <Route path="/join" element={<EventJoin />} />
            <Route path="/join/:code" element={<EventJoin />} />
            <Route path="/e/:id" element={<EventLobby />} />
            <Route path="/e/:id/score" element={<EventScoreEntry />} />
            <Route path="/e/:id/leaderboard" element={<EventLeaderboard />} />
            <Route path="/e/:id/scorecard/:subjectId" element={<Scorecard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
